import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Bookmark = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 20 21"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.0156 1.93604H5.98229C4.20729 1.93604 2.76562 3.38604 2.76562 5.1527V16.8944C2.76562 18.3944 3.84063 19.0277 5.15729 18.3027L9.22396 16.0444C9.65729 15.8027 10.3573 15.8027 10.7823 16.0444L14.849 18.3027C16.1656 19.036 17.2406 18.4027 17.2406 16.8944V5.1527C17.2323 3.38604 15.7906 1.93604 14.0156 1.93604Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Bookmark.displayName = 'Bookmark';
